//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import { ReelsRequest, ReelsResponse } from '@apis/reels/reelsApiModel';
import { makeParams } from '@utils/makeParams';
import { serializedSessionFetch } from '@utils/sessionFetch';

const REELS_BASE_URL = '/api/v2/reels';

const reelsFetch = (endpoint: string, init?: RequestInit) => {
  return serializedSessionFetch(`${REELS_BASE_URL}${endpoint}`, init);
};

/**
 * Get client reels
 *
 * GET /api/v2/reels
 */
export const getReels = async (req: ReelsRequest, init?: RequestInit) => {
  const queryParams = makeParams(req);
  const res = await reelsFetch(`?${queryParams}`, {
    ...(!!init && init),
  });

  return res.json<ReelsResponse>();
};
